import React, { ReactNode } from "react";
import { TooltipProps as MuiTooltipProps } from "@mui/material";
import { StyledTooltip } from "./Tooltip.styled";
import { TooltipTitle } from "./TooltipTitle";

export interface TooltipProps
  extends Omit<MuiTooltipProps, "title" | "children"> {
  children: React.ReactNode;
  title?: ReactNode;
  heading?: string;
  text?: string;
  type?: "dark" | "light";
  scrollable?: boolean;
}

export default function Tooltip({
  children,
  type = "dark",
  title,
  heading,
  text,
  scrollable,
  ...props
}: TooltipProps) {
  const tooltipContent: ReactNode | undefined = title ? (
    title
  ) : text ? (
    <TooltipTitle heading={heading} text={text} />
  ) : (
    heading
  );

  return (
    <StyledTooltip
      type={type}
      title={tooltipContent}
      scrollable={scrollable}
      {...props}
    >
      {children as React.ReactElement}
    </StyledTooltip>
  );
}
